import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Landing } from "./Screens/Landing";

function App() {
  return (
    <Routes>
      <Route exact path="/" element={<Landing />} />
    </Routes>
  );
}

export default App;